module.exports = __webpack_public_path__ + "img/cq9.627276b8.png";